<template>
    <div class="user-notifications" :class="{ 'is-mobile': variant === 'mobile' }" v-show="hasNotifications">
        <button
            ref="button"
            type="button"
            class="notifications-button"
            :class="{ 'has-unread': unvisitedCount > 0 }"
            :aria-label="unvisitedCount > 0 ? 'Notificações: ' + unvisitedCount + ' não lidas' : 'Notificações'"
            :title="unvisitedCount > 0 ? 'Notificações (' + unvisitedCount + ')' : 'Notificações'"
            @click="open()"
        >
            <svg class="bell" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            <span v-if="unvisitedCount > 0" class="badge">{{ unvisitedCount > 9 ? "9+" : unvisitedCount }}</span>
        </button>

        <!-- Backdrop e popup vão para o <body> (mounted): a sidebar tem overflow e cortaria o popup. -->
        <div ref="overlay" class="notifications-overlay">
            <div v-show="show" class="backdrop" :style="{ '--dim-left': dimLeft }" @click="show = false"></div>

            <div :class="'popup ' + (show ? 'active' : '')" :style="popupStyle">
                <div class="popup-body">
                    <div class="alert alert-warning mb-2">
                        {{ t("user_notifications-beta_admin_only") }}
                    </div>
                    <div v-if="notifications.length > 0" class="list-notifications">
                        <div v-for="n in notifications" :key="n.id">
                            <button
                                :class="
                                'notification-text ' +
                                (n.is_visited === '0' ? 'new' : 'old')
                            "
                                @click="visit(n)"
                            >
                                <div v-if="n.is_visited === '0'">
                                    <span class="far fa-circle"></span>
                                </div>
                                <div>
                                    <div class="date">
                                        <human-date :date="n.created_at"/>
                                    </div>
                                    <div>
                                        {{
                                            $_(
                                                "user_notifications-" + n.template,
                                                n.params,
                                            )
                                        }}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else>
                        <div>{{ t("user_notifications-no_notifications") }}</div>
                    </div>
                </div>
                <div class="mark-read">
                    <button class="ml-auto" @click.prevent="markAllVisited">{{ t("user_notifications-mark_all_read") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
// O sino fica dentro da sidebar (na linha do logo), então rola junto com ela.
// Expandida: [logo][sino][recolher]. Recolhida: coluna [marca][recolher][sino].
.user-notifications {
    position: relative;
    display: flex;
    flex: none;
    align-items: center;

    .notifications-button {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        padding: 0;
        border: 0;
        border-radius: 7px;
        background: transparent;
        color: #626473;
        cursor: pointer;
        transition: background-color .2s ease, color .2s ease;

        &:hover {
            background: #f3f3f6;
            color: #1f2337;
        }

        &:focus-visible {
            outline: 2px solid var(--primary, #4a3aff);
            outline-offset: 2px;
        }

        &.has-unread {
            color: #1f2337;
        }
    }

    .badge {
        position: absolute;
        top: -3px;
        right: -4px;
        min-width: 14px;
        height: 14px;
        padding: 0 3px;
        border-radius: 999px;
        background: #f04438;
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        line-height: 14px;
        text-align: center;
        box-shadow: 0 0 0 2px #fff;
        pointer-events: none;
    }

    // No topo azul do mobile o sino é branco.
    &.is-mobile {
        .notifications-button {
            width: 32px;
            height: 32px;
            color: #fff;

            &:hover {
                background: rgba(255, 255, 255, 0.16);
                color: #fff;
            }
        }

        .badge {
            box-shadow: 0 0 0 2px var(--primary, #4a3aff);
        }
    }
}

// Sidebar recolhida (60px): sino um pouco maior para o alvo de clique e anel da cor do fundo.
.header.is-collapsed .user-notifications {
    .notifications-button {
        width: 32px;
        height: 32px;
    }

    .badge {
        box-shadow: 0 0 0 2px #fafafc;
    }
}

.notifications-overlay {
    .backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        z-index: 999;

        // Escurece só o conteúdo; a sidebar continua visível.
        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: var(--dim-left, 0px);
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
        }
    }

    .popup {
        display: none;
        position: fixed;
        padding: 15px;
        left: 242px;
        top: 24px;
        width: 350px;
        border-radius: 8px;
        background-color: white;
        border: 1px solid #e5e6eb;
        box-shadow: 0 8px 24px rgba(16, 24, 40, 0.16);
        z-index: 1000;
        font-size: 14px;
        max-height: 70vh;
        overflow-y: auto;

        &.active {
            display: flex;
            flex-direction: column;
            justify-content: stretch;

            .popup-body {
                overflow-y: auto;
            }
        }

        .mark-read {
            width: 100%;
            padding: 10px;
            background: #f9f9f9;

            button {
                background: transparent;
                border: none;
                color: #626473;
                cursor: pointer;
            }
        }

        .list-notifications {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .notification-text {
                display: flex;
                gap: 10px;
                background: none;
                border: none;
                text-align: left;
                color: #aaa;

                &.new {
                    color: #444;
                }

                .date {
                    font-size: 11px;
                }

                .fa-circle {
                    font-size: 8px;
                }
            }
        }
    }

    @media (max-width: 700px) {
        .backdrop:before {
            left: 0;
            top: 56px;
        }

        .popup {
            left: 12px;
            right: 12px;
            top: 64px;
            width: auto;
            max-height: calc(100vh - 80px);
            max-height: calc(100dvh - 80px);
        }
    }
}
</style>
<script>
import keviApi from "../../keviApi";
import HumanDate from "../../components/human-date/human-date";

const MOBILE_QUERY = "(max-width: 700px)";

export default {
    name: "userNotifications",
    components: {HumanDate},
    props: {
        // "desktop" fica na sidebar; "mobile" fica na barra azul do topo. Só a variante do tamanho atual da tela busca dados.
        variant: {type: String, default: "desktop"},
    },
    data() {
        return {
            notifications: [],
            timeout: null,
            unreadCount: 0,
            unvisitedCount: 0,
            show: false,
            isMobile: window.matchMedia(MOBILE_QUERY).matches,
            popupStyle: {},
            dimLeft: "0px",
        };
    },
    created() {
        this.mediaQuery = window.matchMedia(MOBILE_QUERY);
        this.onMediaChange = (event) => {
            this.isMobile = event.matches;
        };
        if (this.mediaQuery.addEventListener) {
            this.mediaQuery.addEventListener("change", this.onMediaChange);
        } else {
            this.mediaQuery.addListener(this.onMediaChange);
        }
        this.getNotifications();
    },
    mounted() {
        // Tira o popup de dentro da sidebar (overflow) e coloca no body.
        if (this.$refs.overlay) {
            document.body.appendChild(this.$refs.overlay);
        }
    },
    beforeDestroy() {
        window.clearTimeout(this.timeout);
        if (this.mediaQuery) {
            if (this.mediaQuery.removeEventListener) {
                this.mediaQuery.removeEventListener("change", this.onMediaChange);
            } else {
                this.mediaQuery.removeListener(this.onMediaChange);
            }
        }
        const overlay = this.$refs.overlay;
        if (overlay && overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        enabled() {
            return (this.variant === "mobile") === this.isMobile;
        },
        hasNotifications() {
            return this.enabled && this.notifications.length > 0 && this.user.global_admin;
        },
        isLoginPage() {
            const currentPath = this.$route.path;
            return currentPath === "/";
        },
    },
    methods: {
        getLink(notification) {
            if (notification.source === "tasks") {
                const taskId = this.$route.query["task_id"];
                if (
                    taskId === notification.source_id &&
                    this.$route.path === "/tasks"
                ) {
                    return "";
                }
                return "/tasks?task_id=" + notification.source_id;
            }
            return "";
        },
        placePopup() {
            if (this.isMobile) {
                this.popupStyle = {};
                this.dimLeft = "0px";
                return;
            }
            const button = this.$refs.button.getBoundingClientRect();
            const sidebar = document.getElementById("mainHeader");
            const edge = Math.round(sidebar ? sidebar.getBoundingClientRect().right : button.right);
            const top = Math.max(12, Math.round(button.top - 6));
            this.dimLeft = edge + "px";
            this.popupStyle = {
                left: edge + 12 + "px",
                top: top + "px",
                maxHeight: "calc(100vh - " + (top + 16) + "px)",
            };
        },
        open() {
            this.placePopup();
            this.show = true;
            const options = keviApi.getOptions("me/notifications/read", "POST");
            this.$http(options).then((response) => {
                this.unreadCount = response.data.unread_count;
            });
        },
        markAllVisited() {
            this.show = true;
            const options = keviApi.getOptions("me/notifications/visit-all", "POST");
            this.$http(options).then((response) => {
                this.getNotifications();
                this.unvisitedCount = response.data.unvisited_count;
            });
        },
        visit(notification) {
            const options = keviApi.getOptions(
                "me/notifications/" + notification.id + "/visit",
                "POST",
            );
            this.$http(options);
            const link = this.getLink(notification);
            this.$router.push(link);
            this.show = false;
            this.getNotifications();
        },
        getNotifications() {
            if (this.isLoginPage || !this.enabled) {
                return;
            }

            const options = keviApi.getOptions("me/notifications");
            this.$http(options).then((response) => {
                this.notifications = response.data.notifications;
                this.unreadCount = response.data.unread_count;
                this.unvisitedCount = response.data.unvisited_count;
                window.clearTimeout(this.timeout);
                this.timeout = window.setTimeout(() => {
                    this.getNotifications();
                }, 1000*60*5); // 5 minutes
            });
        },
    },
    watch: {
        enabled(isEnabled) {
            if (isEnabled) {
                this.getNotifications();
            } else {
                this.show = false;
            }
        },
        "$route"() {
            if (!this.isLoginPage) {
                this.getNotifications();
            }
        },
    },
};
</script>
